import clsx from 'clsx';
import Select from '@components/common/Select';
import type { SelectOption } from '@components/common/Select';
import Checkbox from '@components/common/Checkbox';
import styles from './CalendarFilters.module.css';

interface CalendarFiltersProps {
  includeCompleted: boolean;
  division: string;
  tier: string;
  assessorId: string;
  status: string;
  divisionOptions: SelectOption[];
  assessorOptions: SelectOption[];
  onFilterChange: (filters: {
    includeCompleted: boolean;
    division: string;
    tier: string;
    assessorId: string;
    status: string;
  }) => void;
  className?: string;
}

const tierOptions: SelectOption[] = [
  { value: '', label: 'All tiers' },
  { value: 'Tier 1', label: 'Tier 1' },
  { value: 'Tier 2', label: 'Tier 2' },
  { value: 'Tier 3', label: 'Tier 3' },
  { value: 'Tier 4', label: 'Tier 4' },
];

const statusOptions: SelectOption[] = [
  { value: '', label: 'All statuses' },
  { value: 'scheduled', label: 'Scheduled' },
  { value: 'rescheduled', label: 'Rescheduled' },
];

export function CalendarFilters({
  includeCompleted,
  division,
  tier,
  assessorId,
  status,
  divisionOptions,
  assessorOptions,
  onFilterChange,
  className,
}: CalendarFiltersProps) {
  const handleChange = (field: string, value: string | boolean) => {
    onFilterChange({
      includeCompleted,
      division,
      tier,
      assessorId,
      status,
      [field]: value,
    });
  };

  return (
    <div className={clsx(styles.filtersContainer, className)}>
      <div className={styles.filterGroup}>
        <Select
          label="Division"
          wrapperClassName={styles.filterField}
          options={divisionOptions}
          value={division}
          onChange={(value) => handleChange('division', value)}
          placeholder="All divisions"
          dataTestId="calendar-filter-division"
        />
      </div>

      <div className={styles.filterGroup}>
        <Select
          label="Tier"
          wrapperClassName={styles.filterField}
          options={tierOptions}
          value={tier}
          onChange={(value) => handleChange('tier', value)}
          placeholder="All tiers"
          dataTestId="calendar-filter-tier"
        />
      </div>

      <div className={styles.filterGroup}>
        <Select
          label="Assessor"
          wrapperClassName={styles.filterField}
          options={assessorOptions}
          value={assessorId}
          onChange={(value) => handleChange('assessorId', value)}
          placeholder="All assessors"
          dataTestId="calendar-filter-assessor"
        />
      </div>

      <div className={styles.filterGroup}>
        <Select
          label="Status"
          wrapperClassName={styles.filterField}
          options={statusOptions}
          value={status}
          onChange={(value) => handleChange('status', value)}
          placeholder="All statuses"
          dataTestId="calendar-filter-status"
        />
      </div>

      <div className={styles.toggleGroup}>
        <Checkbox
          label="Show Completed / Cancelled"
          checked={includeCompleted}
          onChange={(e) => handleChange('includeCompleted', e.target.checked)}
          dataTestId="calendar-filter-completed"
        />
      </div>
    </div>
  );
}
